import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ClubDiscountCounter } from '../interfaces/club-discount-counter';
import { ClubDiscount } from '../interfaces/club-discount';
import { CodeDiscount } from '../interfaces/code-discount';
import { SiblingDiscount } from '../interfaces/sibling-discount';
import { EarlyBirdDiscount } from '../interfaces/early-bird-discount';
import { ClubDiscountDetails } from '../interfaces/club-discount-details';

import { Fees } from '../models/fees/fees';

@Injectable()
export class ClubDiscountService {
  private _url = '/api/ClubDiscount/';
  private _feeUrl = '/api/Fees';

  constructor(private http: HttpClient) { }

  getDiscountCount(clubProgramID: string | number) {
    return this.http.get<ClubDiscountCounter>(this._url + 'getDiscountCounts/' + clubProgramID);
  }

  getDiscountUsers(clubProgramID: string | number) {
    return this.http.get<any>(this._url + 'getDiscountUsers/' + clubProgramID);
  }

  getDiscounts(clubProgramID: string | number): Observable<ClubDiscount[]> {
    return this.http.get<ClubDiscount[]>(this._url + 'getDiscountList/' + clubProgramID);
  }

  getDiscountDetails(discountId: string): Observable<ClubDiscountDetails[]> {
    return this.http.get<ClubDiscountDetails[]>(this._url + 'getSingleDiscount/' + discountId);
  }

  deleteDiscount(clubProgramId, questionIds: string) {
    return this.http.delete(this._url + `delete-discounts/${clubProgramId}/` + questionIds);
  }

  changeDiscountStatus(questionIds: string, status: number) {
    return this.http.post(this._url + `discounts-status/${questionIds}/${status}`, {});
  }

  getFees(programId: string | number): Observable<Fees[]> {
    // return this.http.get<Fees[]>(this._feeUrl + 'program-fees/' + programId);
    console.log('program id 44', programId);
    return this.http.get<Fees[]>(this._feeUrl + '/feeNames/' + programId);
  }

  // Create Sibling Discount.
  createSiblingDiscount(siblingDiscount: SiblingDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'addsiblingdiscount', siblingDiscount, httpOptions);
  }

  // Create Code Discount.
  createCodeDiscount(codeDiscount: CodeDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'addcodediscount', codeDiscount, httpOptions);
  }

  // Create Earlybird Discount.
  createEarlyBirdDiscount(earlyBirdDiscount: EarlyBirdDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'addearlybirddiscount', earlyBirdDiscount, httpOptions);
  }

  // Edit Sibling Discount.
  editSiblingDiscount(siblingDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'editsiblingdiscount', siblingDiscount, httpOptions);
  }

  // Edit Code Discount.
  editCodeDiscount(codeDiscount: CodeDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'editcodediscount', codeDiscount, httpOptions);
  }

  // Edit Earlybird Discount.
  editEarlyBirdDiscount(earlyBirdDiscount: EarlyBirdDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'updateDiscountCodes', earlyBirdDiscount, httpOptions);
  }

  deleteProgramFeeDiscount(data) {
    return this.http.post(this._url + 'delete-discount', data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/club-discount.service.ts